<template>
  <tr class="border-b-1 border-b-gray-600">
    <th>
      <sort-control
        field="name"
        :selected="currentSortField === 'name'"
        v-on="listeners"
        >Name</sort-control
      >
    </th>
    <th class="hide-mobile">
      Expression
    </th>
    <th></th>
  </tr>
</template>
<script>
import SortControl from "@/components/common/tables/SortControl.vue";

export default {
  components: { SortControl },
  props: ["currentSortField"],
  computed: {
    listeners: function() {
      // Vue 3: $listeners merged into $attrs
      return this.$attrs;
    },
  },
};
</script>
